module.exports = __webpack_public_path__ + "static/img/dsk-projects-bg1.1721945.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-projects-bg1.jpg
// module id = 234
// module chunks = 1